import {
  FaChartLine,
  FaPhone,
  FaUsers,
  FaClipboardList,
  FaLaptopCode,
  FaBell,
  FaCog,
  FaBox,
  FaLifeRing,
  FaUserPlus,
  FaBullseye,
  FaPaperPlane,
  FaTrophy,
  FaHistory,
  FaDatabase
 
} from "react-icons/fa";
import TelesalesDashboard from "../dashboard/TelesalesDashboard";

 const menuByRole = {

 telesales: [
    { name: "Dashboard", path: "/telesales", icon: <FaChartLine /> },
    { name: "Call Logs", path: "/telesales/calllogs", icon: <FaPhone /> },
    { name: "Follow Ups", path: "/telesales/followups", icon: <FaClipboardList /> },
    { name: "Meetings", path: "/telesales/meetings", icon: <FaLaptopCode /> },
    // { name: "Daily Summary", path: "/telesales/dailysummary", icon: <FaClipboardList /> },
    { name: "Packages", path: "/itmanager/packages", icon: <FaBox /> },
    { name: "My Target", path: "/telesales/my-target", icon: <FaBullseye /> },
    { name: "Submit Achievement", path: "/telesales/submit-achievement", icon: <FaPaperPlane /> },
    { name: "Notifications", path: "/telesales/notifications", icon: <FaBell /> },
    { name:  "Settings",path:"/telesales/settings",icon:<FaCog/>}

    
  ],

salesexec: [
    { name: "Dashboard", path: "/salesexec", icon: <FaUsers /> },
    { name: "Call Logs", path: "/salesexec/calllogs", icon: <FaPhone /> },
    { name: "Follow Ups", path: "/salesexec/followups", icon: <FaClipboardList /> },
    { name: "Meetings", path: "/salesexec/meetings", icon: <FaLaptopCode /> },
    // { name: "Daily Summary", path: "/salesexec/dailysummary", icon: <FaClipboardList /> },
    { name: "Packages", path: "/salesexec/packages", icon: <FaBox /> },
    { name: "My Target", path: "/salesexec/my-target", icon: <FaBullseye /> },
    { name: "Submit Achievement", path: "/salesexec/submit-achievement", icon: <FaPaperPlane /> },
    { name: "Notifications", path: "/salesexec/notifications", icon: <FaBell /> },
    { name: "Settings", path: "/salesexec/settings", icon: <FaCog /> }
  ],

 boss: [
  
  {name: "Dashboard", path: "/boss", icon: <FaChartLine /> },
  {name: "Notifications", path: "/boss/notifications", icon: <FaBell /> },
  { name: "IT Manager", path: "/boss/itmanager", icon: <FaLaptopCode /> },
  { name: "Employees", path: "/boss/employees", icon: <FaUsers /> },
  { name: "Add Employee", path: "/boss/add-employee", icon: <FaUserPlus /> },
  { name: "Call Logs", path: "/boss/calllogs", icon: <FaPhone /> },
  { name: "Meetings", path: "/boss/meetings", icon: <FaLaptopCode /> },

  /* NEW: Target Management + Notification System (Admin) */
  { name: "Target Management", path: "/boss/target-management", icon: <FaBullseye /> },
  { name: "Achievements", path: "/boss/achievements", icon: <FaTrophy /> },
  { name: "Activity Logs", path: "/boss/activity-logs", icon: <FaHistory /> },
  { name: "Global Explorer", path: "/boss/global-explorer", icon: <FaDatabase /> }
 
],

 itmanager: [
  { name: "Dashboard", path: "/itmanager", icon: <FaLaptopCode /> },
  { name: "Packages", path: "/itmanager/packages", icon: <FaBox /> },
  { name: "Service Details", path: "/itmanager/services", icon: <FaClipboardList /> },
  { name: "Users", path: "/itmanager/employees", icon: <FaUsers /> },
 
  { name: "Notifications", path: "/itmanager/notifications", icon: <FaBell /> },
  { name: "Settings", path: "/itmanager/settings", icon: <FaCog /> }
],

manager: [
  { name: "Dashboard", path: "/manager", icon: <FaChartLine /> },
  { name: "All Leads", path: "/manager/leads", icon: <FaClipboardList /> },
  { name: "Team", path: "/manager/team", icon: <FaUsers /> },
  { name: "Performance", path: "/manager/performance", icon: <FaUserPlus /> },
  { name: "Settings", path: "/manager/settings", icon: <FaCog /> }
]
};

export default menuByRole;